import React from 'react';

export default function Terms() {
  return (
    <div style={{ padding: '3rem 1.5rem', maxWidth: 800, margin: '0 auto' }}>
      <h1 style={{ fontSize: '32px', marginBottom: '1.5rem', color: '#1e1e1e' }}>
        Terms &amp; Conditions
      </h1>

      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', marginBottom: '1rem' }}>
        <strong>First Dance – Wedding Planner App</strong>
        <br />
        Last updated: 28th January 2026
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        1. About Us
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        First Dance (“we”, “us”, “our”) is a UK-based mobile application designed to help couples plan
        their wedding. These Terms and Conditions (“Terms”) govern your use of the First Dance mobile
        application and any related services (“App”).
      </p>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        By creating an account or using the App, you agree to be bound by these Terms. If you do not
        agree, you must not use the App.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        2. Eligibility
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        You must be at least 18 years old to use the App. By using First Dance, you confirm that you
        meet this requirement.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        3. Account Registration
      </h2>
      <ul style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', paddingLeft: '1.2rem' }}>
        <li>You must provide accurate, current, and complete information when creating an account.</li>
        <li>You are responsible for maintaining the confidentiality of your login details.</li>
        <li>You are responsible for all activity that occurs under your account.</li>
        <li>We reserve the right to suspend or terminate accounts that breach these Terms.</li>
      </ul>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        4. Subscription Plans &amp; Payments
      </h2>
      <h3 style={{ fontSize: '16px', marginTop: '1rem', marginBottom: '0.3rem', color: '#1e1e1e' }}>
        4.1 Free Account
      </h3>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        First Dance offers a free version with limited features (“Free Account”). Features available
        under the Free Account may change at any time.
      </p>

      <h3 style={{ fontSize: '16px', marginTop: '1rem', marginBottom: '0.3rem', color: '#1e1e1e' }}>
        4.2 Diamond Plan (Monthly Subscription)
      </h3>
      <ul style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', paddingLeft: '1.2rem' }}>
        <li>The Diamond Plan is a recurring monthly subscription that provides access to premium features.</li>
        <li>Payment is charged monthly in advance.</li>
        <li>The subscription can be cancelled at any time.</li>
        <li>No refunds are provided for partial or unused subscription periods.</li>
        <li>Cancellation will take effect at the end of the current billing cycle.</li>
      </ul>

      <h3 style={{ fontSize: '16px', marginTop: '1rem', marginBottom: '0.3rem', color: '#1e1e1e' }}>
        4.3 Ever After Plan (One-Off Payment)
      </h3>
      <ul style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', paddingLeft: '1.2rem' }}>
        <li>
          The Ever After Plan is a one-time payment that provides access to premium features until 6
          months after the user’s wedding date.
        </li>
        <li>Access automatically ends 6 months after the wedding date provided by the user.</li>
        <li>Users are responsible for ensuring their wedding date is accurate.</li>
      </ul>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        5. Cooling-Off Period &amp; Refunds
      </h2>
      <h3 style={{ fontSize: '16px', marginTop: '1rem', marginBottom: '0.3rem', color: '#1e1e1e' }}>
        5.1 Ever After Plan Refund Policy
      </h3>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        In accordance with UK consumer law, users purchasing the Ever After Plan are entitled to a
        7-day cooling-off period starting from the date of purchase.
      </p>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>To request a refund:</p>
      <ul style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', paddingLeft: '1.2rem' }}>
        <li>The user must submit a request via our official Refund Request Form.</li>
        <li>Refund requests must be received within 7 days of purchase.</li>
      </ul>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>Any approved refund:</p>
      <ul style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', paddingLeft: '1.2rem' }}>
        <li>Will exclude any processing or transaction fees incurred by us.</li>
        <li>Will be issued to the original payment method.</li>
      </ul>

      <h3 style={{ fontSize: '16px', marginTop: '1rem', marginBottom: '0.3rem', color: '#1e1e1e' }}>
        5.2 Diamond Plan Refund Policy
      </h3>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        The Diamond Plan is non-refundable. This includes situations where:
      </p>
      <ul style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', paddingLeft: '1.2rem' }}>
        <li>The subscription is cancelled mid-billing cycle.</li>
        <li>The App is no longer used.</li>
      </ul>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        6. Changes to Pricing or Plans
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        We reserve the right to change pricing, features, or availability of plans at any time. Any
        changes will not affect payments already made.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        7. App Usage Rules
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>You agree not to:</p>
      <ul style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', paddingLeft: '1.2rem' }}>
        <li>Use the App for unlawful purposes.</li>
        <li>Attempt to reverse engineer or disrupt the App.</li>
        <li>Upload harmful, misleading, or infringing content.</li>
      </ul>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        We may suspend or terminate access if these rules are breached.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        8. Intellectual Property
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        All content, branding, features, and software within the App are owned by or licensed to First
        Dance. You may not copy, modify, distribute, or exploit any part of the App without written
        permission.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        9. User Content
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        You retain ownership of any content you upload, but grant us a non-exclusive licence to use it
        for operating and improving the App.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        10. Data Protection &amp; Privacy
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        We process personal data in accordance with UK GDPR and applicable data protection laws. Please
        refer to our Privacy Policy for full details on how your data is handled.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        11. Service Availability
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        We aim to keep the App available at all times but do not guarantee uninterrupted or error-free
        service. We may suspend access for maintenance or updates.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        12. Limitation of Liability
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        To the maximum extent permitted by law:
      </p>
      <ul style={{ fontSize: '14px', lineHeight: 1.7, color: '#333', paddingLeft: '1.2rem' }}>
        <li>We are not liable for indirect or consequential losses.</li>
        <li>We do not guarantee specific wedding outcomes or results.</li>
        <li>
          Nothing in these Terms limits liability for fraud, death, or personal injury caused by
          negligence.
        </li>
      </ul>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        13. Termination
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        We may suspend or terminate your account if you breach these Terms. You may stop using the App
        at any time.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        14. Governing Law
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        These Terms are governed by and interpreted in accordance with the laws of England and Wales.
        Any disputes shall be subject to the exclusive jurisdiction of the courts of England and
        Wales.
      </p>

      <h2 style={{ fontSize: '20px', marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1e1e1e' }}>
        15. Contact Us
      </h2>
      <p style={{ fontSize: '14px', lineHeight: 1.7, color: '#333' }}>
        For support, refund requests, or legal enquiries, please contact us via the support tool in the app.
      </p>

    </div>
  );
}

